import {curry} from 'ramda';
import {createAction} from 'redux-actions';
import tryToCatch from 'try-to-catch';
import {setNotificationAction} from '@pluto/notification';
import {createSnapshot, deleteSnapshot} from '@pluto/rest';
import {DispatchAny} from '@pluto/@types';
import {setActiveTabAction} from '../../Redux/QCTabsActions';

export const FETCH_SNAPSHOTS = 'FETCH_SNAPSHOTS';
export const RESET_SNAPSHOTS = 'RESET_SNAPSHOTS';
export const START_CREATE_SNAPSHOT = 'START_CREATE_SNAPSHOT';
export const START_FETCH_SNAPSHOTS = 'START_FETCH_SNAPSHOTS';

export enum SnapshotStatus {
    DONE = 'DONE',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
}

export interface QCSnapshot {
    assetId: number;
    frameNumber: number;
    videoFileId: number;
    id: number;
    url: string;
    status: SnapshotStatus;
}

const isCorrectQc = (id: number) => window.location.pathname.includes(String(id));

export const predicate = (id: number) => (data: QCSnapshot[]) => {
    return isCorrectQc(id) && data.some((item) => item.status === SnapshotStatus.PENDING);
};

export const setSnapshotsAction = createAction(FETCH_SNAPSHOTS);
export const resetSnapshotsAction = createAction(RESET_SNAPSHOTS);

export const deleteSnapshotAction = curry(
    async (
        qcId: number,
        snapshotId: number,
        videoFileId: number,
        dispatch: DispatchAny
    ) => {
        const [error] = await tryToCatch(deleteSnapshot, snapshotId);

        if (error) {
            return dispatch(
                setNotificationAction({
                    type: 'error',
                    text: 'Failed to delete snapshot',
                })
            );
        }

        dispatch({
            type: START_FETCH_SNAPSHOTS,
            videoFileId
        });
    }
);

const snapshotTab = 3;

export const createSnapshotAction = curry(
    async (
        id: number,
        snapshotFrame: number,
        videoFileId: number,
        dispatch: DispatchAny
    ) => {
        const [error] = await tryToCatch(createSnapshot, snapshotFrame, videoFileId);

        if (error) {
            return dispatch(
                setNotificationAction({
                    type: 'error',
                    text: 'Failed to get snapshot',
                })
            );
        }

        dispatch({
            type: START_FETCH_SNAPSHOTS,
            videoFileId
        });

        dispatch(setActiveTabAction(snapshotTab));
    }
);

export type CreateSnapshotAction = (
    id: string,
    snapshotFrame: number,
    videoFileId: number
) => Promise<void>;

export type DeleteSnapshotAction = (
    qcId: number,
    id: number,
    videoFileId: number
) => Promise<void>;
